import { render, staticRenderFns } from "./display.modal.vue?vue&type=template&id=6c65afc2&scoped=true"
import script from "./display.modal.vue?vue&type=script&lang=js"
export * from "./display.modal.vue?vue&type=script&lang=js"
import style0 from "./display.modal.vue?vue&type=style&index=0&id=6c65afc2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c65afc2",
  null
  
)

export default component.exports